<template>
        <v-container>
            <v-layout align-center justify-center>
                <v-flex class="test-xs-center">
                    <v-card dark>
                        <v-card-text>
                          <v-row align="center">
                            <v-col class="text-h2" cols=6><v-img contain src="/img/cinestaff.png" max-width="500"></v-img></v-col>
                          </v-row>
                          <p class="text-caption">Version {{$store.state.version}}</p>
                          <h1>Connexion</h1>
                          <v-form>
                          <v-text-field prepend-icon='mdi-account' label="Nom d'utilisateur" v-model="username"></v-text-field>
                          <v-text-field prepend-icon='mdi-key' @keydown="onKeydown" type="password" label='Mot de passe' v-model="password"></v-text-field>
                          <v-btn @click="_login()" color="secondary">Login</v-btn>
                      </v-form>
                      </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
</template>

<script>
import api from "@/api";
import { login } from "@/auth";



export default {
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    onKeydown(event){
      if (event.key == "Enter") {
        this._login();
      }
    },
    async _login() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000
      });
      let res = await api.login(this.username, this.password);
      Toast.fire({
        icon: res.code === 200 ? "success" : "error",
        title: res.message
      });
      if (res.data && res.data.token) {
        login(res.data.token);
      }
    }
  }
};
</script>